// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2mPcx","actions":"GroupTable_actions__ObtW9","deleteModalFooter":"GroupTable_deleteModalFooter__2mWxk"};